import * as React from "react"
import Svg, {ClipPath, Defs, G, Path} from "react-native-svg"

type Props = {
  toggleSelection: (part: string) => void;
  isSelected: (part: string) => boolean;
};

export default function FrontBodyDiagramComponent({
  toggleSelection,
  isSelected,
  }: Props){
  return (
    <Svg
      width={204}
      height={570}
      viewBox="0 0 204 570"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#clip0_3735_23010)" stroke="#000">
        <Path
          d="M120.859 267.102h-38.5c6.17 9.34 12.26 25.98 18.87 26.69 7.16.77 16.14-23.19 19.63-26.69z"
          fill={isSelected("pelvis_front") ? "#FF2C82" : "#FFCCE1"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("pelvis_front")}
        />
        <Path
          d="M73.2 525.862c-5.51 2.27-14.12 16.19-15.85 17.66-1.73 1.47-7.06 1.73-8.53 3.06-1.47 1.33-10.53 9.59-7.19 17.19 3.34 7.6 14.98 4.42 18.36 3.19 3.38-1.23 12.91-.61 15.06-4 2.15-3.39 10.07-9.98 18.45-14.45 4.5-2.4 4.27-4.31 5.29-9.16 1.02-4.85-3.24-8.76-2.98-13.1l-22.61-.4v.01z"
          fill={isSelected("right_foot_front") ? "#F94E19" : "#FED9CD"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("right_foot_front")}
        />
        <Path
          d="M95.501 526.258c.187 0 .353-.107.403-.286 1.573-5.695-7.502-26.692-3.493-42.494 4.08-16.07 7.65-38.01 6.38-51.28-1.27-13.27-7.38-20.16-2.92-31.12h-33.9c-7.15 53.52 8.13 94.83 9.95 103.11 1.82 8.28.09 8.01-.84 13.34-.93 5.33 2.64 5.25 2.13 8.32l22.29.41z"
          fill={isSelected("right_knee_front") ? "#F94E19" : "#FED9CD"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("right_knee_front")}
        />
        <Path
          d="M101.461 293.741c0 30.07-5.07 63.29-5.15 77.46-.08 14.17.94 27.27-.37 29.83h-33.9c3.13-36.21-17.22-68.28-13.19-128.74.65-19.87 5.51-24.16 6.54-35.51 2.94 6.32 12.71 10.19 26.98 30.33 5.71 8.06 12.96 27.57 19.1 26.64l-.01-.01z"
          fill={isSelected("right_thigh_front") ? "#F94E19" : "#FED9CD"}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          onClick={() => toggleSelection("right_thigh_front")}
        />
        <Path
          d="M130.131 525.862c5.51 2.27 14.12 16.19 15.85 17.66 1.73 1.47 7.06 1.73 8.53 3.06 1.47 1.33 10.53 9.59 7.19 17.19-3.34 7.6-14.98 4.42-18.36 3.19-3.38-1.23-12.91-.61-15.06-4-2.15-3.39-10.07-9.98-18.45-14.45-4.5-2.4-4.27-4.31-5.29-9.16-1.02-4.85 3.24-8.76 2.98-13.1l22.61-.4v.01z"
          fill={isSelected("left_foot_front") ? "#FF99FF" : "#FCF"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("left_foot_front")}
        />
        <Path
          d="M107.621 526.289c-.308 0-.588-.187-.654-.487-1.318-5.972 7.506-26.671 3.543-42.293-4.08-16.07-7.65-38.01-6.38-51.28 1.27-13.27 7.38-20.16 2.92-31.12h33.9c7.15 53.52-8.13 94.83-9.95 103.11-1.82 8.28-.09 8.01.84 13.34.93 5.33-2.64 5.25-2.13 8.32l-22.089.41z"
          fill={isSelected("left_knee_front") ? "#FF99FF" : "#FCF"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("left_knee_front")}
        />
        <Path
          d="M101.61 293.741c0 30.07 5.07 63.29 5.15 77.46.09 14.17-1.51 28.63.37 29.83h33.9c-3.13-36.21 17.22-68.28 13.19-128.74-.65-19.87-5.51-24.16-6.54-35.51-2.94 6.32-12.71 10.19-26.98 30.33-5.71 8.06-12.96 27.57-19.1 26.64l.01-.01z"
          fill={isSelected("left_thigh_front") ? "#FF99FF" : "#FCF"}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          onClick={() => toggleSelection("left_thigh_front")}
        />
        <Path
          d="M82.36 267.1c-11.15-16.36-25.82-25.97-26.9-30.27.61-5.36 1.24-19.64 1.78-24.03 13.44-4.3 21.42-19.16 26.64-30.65 4.65-10.26 10.29-27.12 17.661-25.83v110.77h-19.18v.01z"
          fill={isSelected("right_abdomen_front") ? "#FF2C82" : "#FFCCE1"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("right_abdomen_front")}
        />
        <Path
          d="M120.561 267.1c11.15-16.36 25.82-25.97 26.9-30.27-.61-5.36-1.24-19.64-1.78-24.03-13.44-4.3-21.42-19.16-26.64-30.65-4.65-10.26-10.29-27.12-17.66-25.83v110.77h19.18v.01z"
          fill={isSelected("left_abdomen_front") ? "#FF2C82" : "#FFCCE1"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("left_abdomen_front")}
        />
        <Path
          d="M101.389 156.32c-13.3-2.13-17.8 49.53-44.39 56.57 1.15-8.39 3.46-22.47 0-30.89-3.46-8.43-2.64-36.04-4-39.26-1.36-3.22-3.84-4.54-4.3-7.33h52.69v20.92-.01z"
          fill={isSelected("right_chest_front") ? "#FFA233" : "#FFE8CC"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("right_chest_front")}
        />
        <Path
          d="M79.84 145.84a2.33 2.33 0 100-4.66 2.33 2.33 0 000 4.66z"
          fill={isSelected("right_chest_front") ? "#FFA233" : "#FFE8CC"}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("right_chest_front")}
        />
        <Path
          d="M101.391 156.32c13.3-2.13 17.8 49.53 44.39 56.57-1.15-8.39-3.46-22.47 0-30.89 3.46-8.43 2.64-36.04 4-39.26 1.36-3.22 3.84-4.54 4.3-7.33h-52.69v20.92-.01z"
          fill={isSelected("left_chest_front") ? "#FFA233" : "#FFE8CC"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("left_chest_front")}
        />
        <Path
          d="M120.631 145.84a2.33 2.33 0 100-4.66 2.33 2.33 0 000 4.66z"
          fill={isSelected("left_chest_front") ? "#FFA233" : "#FFE8CC"}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("left_chest_front")}
        />
        <Path
          d="M17.25 279.32c-2.62 3.3-10.51 16.17-11.69 18.4-1.18 2.23-7.25 14.21-3.7 16.58 3.55 2.37 7.55-5.77 8.29-6.22.74-.45-1.04 17.92 2.81 21.47 3.85 3.55 8 2.07 10.96 1.63 2.96-.44 4.29-5.18 5.33-4.74 1.04.44 3.11-.3 3.85-2.81 8.98-18.07 3.48-38.76 3.31-44.31H17.25z"
          fill={isSelected("right_hand_front") ? "#772EFF" : "#DECCFF"}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          onClick={() => toggleSelection("right_hand_front")}
        />
        <Path
          d="M36.4 279.32c.53-5.55 3.58-11.8 5.5-18.46 3.45-12.43 6.15-27.16 7.71-37.07 1.17-7.46 1.56-19.96 3.6-25.85 0 0-5.99 3.86-13.41 1.87-7.42-1.99-11.4-7.29-11.4-7.29 0 .97-2.14 6.83-4.2 19.51-2.06 12.68-1.66 41.19-3.24 46.66-.86 2.98-2.27 16.53-3.7 20.62l19.14.01z"
          fill={isSelected("right_forearm_front") ? "#772EFF" : "#DECCFF"}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          onClick={() => toggleSelection("right_forearm_front")}
        />
        <Path
          d="M28.4 192.518c0-.97-1.6-40.24 1.49-57.12h18.82s.08 1.42 1.86 3.55c2.5 2.99 2.64 4.33 2.74 5.16.82 6.67.72 30.72 3.7 37.88-.58 4.63-2.08 14.74-3.79 15.94-3.27 2.3-8.69 2.92-12.89 2.03-7.25-1.54-11.93-7.45-11.93-7.45v.01z"
          fill={isSelected("right_upper_arm_front") ? "#772EFF" : "#DECCFF"}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          onClick={() => toggleSelection("right_upper_arm_front")}
        />
        <Path
          d="M185.94 279.32c2.62 3.3 10.51 16.17 11.69 18.4 1.18 2.23 7.25 14.21 3.7 16.58-3.55 2.37-7.55-5.77-8.29-6.22-.74-.45 1.04 17.92-2.81 21.47-3.85 3.55-8 2.07-10.96 1.63-2.96-.44-4.29-5.18-5.33-4.74-1.04.44-3.11-.3-3.85-2.81-8.98-18.07-3.643-38.76-3.473-44.31h19.323z"
          fill={isSelected("left_hand_front") ? "#3BC3C1" : "#D8F3F3"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("left_hand_front")}
        />
        <Path
          d="M166.5 279.31c-.53-5.55-3.53-11.79-5.45-18.45-3.45-12.43-6.15-27.16-7.71-37.07-1.17-7.46-1.56-19.96-3.6-25.85 0 0 5.99 3.86 13.41 1.87 7.42-1.99 11.4-7.29 11.4-7.29 0 .97 2.14 6.83 4.2 19.51 2.06 12.68 1.66 41.19 3.24 46.66.86 2.98 2.27 16.53 3.7 20.62l-17.19.01-2-.01z"
          fill={isSelected("left_forearm_front") ? "#3BC3C1" : "#D8F3F3"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("left_forearm_front")}
        />
        <Path
          d="M174.38 192.518c0-.97 1.6-40.24-1.49-57.12h-18.82s-.08 1.42-1.86 3.55c-2.5 2.99-2.64 4.33-2.74 5.16-.82 6.67-.72 30.72-3.7 37.88.58 4.63 2.08 14.74 3.79 15.94 3.27 2.3 8.69 2.92 12.89 2.03 7.25-1.54 11.93-7.45 11.93-7.45v.01z"
          fill={isSelected("left_upper_arm_front") ? "#3BC3C1" : "#D8F3F3"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("left_upper_arm_front")}
        />
        <Path
          d="M101.39 135.411H29.88s-4.92-20.2 3.22-29.46c8.14-9.26 13.6-12.76 20.35-12.76 6.75 0 8.35 2.76 25.99 3.23 9.06.24 13.99-.01 17.53 2.41 2.67 1.82 3.23 2.43 4.41 2.48v34.11l.01-.01z"
          fill={isSelected("right_shoulder_front") ? "#772EFF" : "#DECCFF"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("right_shoulder_front")}
        />
        <Path
          d="M101.391 135.411h71.51s4.92-20.2-3.22-29.46c-8.14-9.26-13.6-12.76-20.35-12.76-6.75 0-8.35 2.76-25.99 3.23-9.06.24-13.99-.01-17.53 2.41-2.67 1.82-3.23 2.43-4.41 2.48v34.11l-.01-.01z"
          fill={isSelected("left_shoulder_front") ? "#3BC3C1" : "#D8F3F3"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("left_shoulder_front")}
        />
        <Path
          d="M52.87 93.171c0 .004-.003.011 0 .01.182-.117 16.422-10.543 20.55-11.1 3.3-.45 7.89-7.17 7.95-10.35.06-3.18 0-14.86 0-14.86s7.96 19.41 19.729 19.1c11.77-.31 19.88-15.13 21.2-19.1-1.73 6.11-3.01 13.96-2.34 16.5.3 1.15 2.01 5.93 7 7.06 4.7 1.06 13.63 9.41 20.45 12.69-7.83 3.41-29.53 4.14-37.02 3.98-2.29 0-7.32 4.1-9 4.18-1.82.08-4.02-3.16-8.15-4.09-4.13-.93-11.88-.55-19.78-1.04-6.77-.43-13.29-1.94-16.53-2.72-1.37-.33-4.06-.26-4.06-.26z"
          fill={isSelected("neck_front") ? "#FFE000" : "#FFF9CC"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("neck_front")}
        />
        <Path
          d="M101.39 75.97c-13.62.11-20.57-18.21-20.57-18.21s-5.7.22-8.43-10.11c-2.94-11.15-2.02-14.04 1.27-14.97.1-5.28-1.55-30.43 27.73-31.88v75.18-.01z"
          fill={isSelected("head_right_front") ? "#FFE000" : "#FFF9CC"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("head_right_front")}
        />

        <Path
          d="M101.391 75.97c13.62.11 20.57-18.21 20.57-18.21s5.7.22 8.43-10.11c2.94-11.15 2.02-14.04-1.27-14.97-.1-5.28 1.55-30.43-27.73-31.88v75.18-.01z"
          fill={isSelected("head_left_front") ? "#FFE000" : "#FFF9CC"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          onClick={() => toggleSelection("head_left_front")}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_3735_23010">
          <Path fill="#fff" d="M0 0H203.19V569.42H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}
